import { useState, useRef, useEffect } from "react";
import { useCommon } from "../../../context/CommonContext";
import { Accordion, Card, Row, Col, Form } from "react-bootstrap";
import "./Faimily.css";
import { toast } from "react-toastify";
import Loader from "../../../components/Loader";
import jsSHA from "jssha";
import { v4 as uuidv4 } from "uuid";
import { ncdAPI } from "../../../services/ncd.api";
import Select, { components } from "react-select";
import Tooltip from "@mui/material/Tooltip";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import {
  formatToApiDate,
  formatToInputDate,
  formatDateAge,
  calculateAge,
} from "../../../helpers/common-helper";

export const Faimily = ({
  hideSection,
  profileData,
  setshowCBACform,
  setIndividualId,
  setFamilyInfo,
  setShowNcdReg,
  onRegistrationSuccess,
}) => {
  const [isPageLoading, setIsPageLoading] = useState(false);
  const [enrollmentForId, setEnrollFId] = useState("");
  const [formDetails, setformDetails] = useState("");
  const [user, setUser] = useState(null);
  const [villages, setvillages] = useState(null);
  const [subusers, setsubUsers] = useState(null);
  const [ashas, setAshas] = useState(null);
  const [districts, setDistricts] = useState(null);
  const [talukas, setTalukas] = useState(null);
  const [phcs, setPHCs] = useState(null);
  const [subcenters, setSubcenters] = useState(null);
  const [selectedDistrict, setSelectedDistrict] = useState(null);
  const [selectedTaluka, setSelectedTaluka] = useState(null);
  const [selectedPHC, setSelectedPHC] = useState(null);
  const [selectedSubcenter, setSelectedSubcenter] = useState(null);
  const [age, setAge] = useState(null); // State for calculated age
  const [enrollmentDate] = useState(() => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0");
    const day = String(today.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`; // format for input type="date"
  });

  const [formErrors, setFormErrors] = useState({});

  const [photoError, setPhotoError] = useState("");

  const fileInputRef = useRef(null);

  const { ncduser } = useCommon();

  // Encrypt function using SHA-256
  const encryptValue = (inputValue) => {
    const hashValue = new jsSHA("SHA-256", "TEXT", { numRounds: 1 });
    hashValue.update(inputValue);
    return hashValue.getHash("HEX");
  };

  const handleDateChange = (e) => {
    if (e.target.name === "individualInfo.additionalDetails.enrollmentDate") {
      const selectedDate = new Date(e.target.value); // Parse the date string
      const formattedDate = selectedDate
        .toLocaleDateString("en-GB", {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
        })
        .replace(/\//g, "-"); // Format to dd-mm-yy

      setFormData((prevData) => ({
        ...prevData,
        individualInfo: {
          ...prevData.individualInfo,
          additionalDetails: {
            ...prevData.individualInfo.additionalDetails,
            enrollmentDate: formattedDate,
          },
        },
      }));
    }
  };

  useEffect(() => {
    setEnrollFId(
      encryptValue(ncduser.loginuser + new Date().getTime() + uuidv4()),
    );

    setUser(ncduser);
    getDetails(
      ncduser.facilityTypeId,
      ncduser.facility,
      ncduser.facilityType,
      ncduser.rolename,
    );

    if (profileData?.dob) {
      const formadDate = formatDateAge(profileData.dob);
      const calage = calculateAge(formadDate);
      setAge(calage);

      setFormData((prev) => ({
        ...prev,
        individualInfo: {
          ...prev.individualInfo,
          age: calage,
        },
      }));
    }
  }, [profileData.dob]);

  useEffect(() => {
    if (user?.username) {
      setFormData((prev) => {
        if (!prev.familyInfo.addressInfo.subcenterName) {
          return {
            ...prev,
            familyInfo: {
              ...prev.familyInfo,
              addressInfo: {
                ...prev.familyInfo.addressInfo,
                subcenterName: user.username,
              },
            },
          };
        }
        return prev;
      });
    }
  }, [user]);

  // 👇 Once enrollmentForId is ready, update the formData
  useEffect(() => {
    if (enrollmentForId) {
      setFormData((prev) => ({
        ...prev,
        enrollmentFormId: enrollmentForId,
      }));
    }
  }, [enrollmentForId]);

  const getDetails = async (
    facilityTypeId,
    facility,
    facilityType,
    rolename,
  ) => {
    try {
      setIsPageLoading(true);

      if (
        rolename === "MO" ||
        rolename === "DEO" ||
        rolename === "STAFF_NURSE"
      ) {
        if (facilityType === "PHC") {
          const facilityDetails = await ncdAPI.getFacilityDetails(
            facilityTypeId,
            facility,
          );

          setformDetails(facilityDetails.data);

          if (facilityDetails.data?.locationHierarchy) {
            const hierarchy = facilityDetails.data.locationHierarchy;
            setSelectedDistrict(hierarchy.districtId);
            setSelectedTaluka(hierarchy.talukaId);
            setSelectedPHC(facilityDetails.data.facilityId);
          }

          if (facilityDetails.data?.locationHierarchy?.stateId) {
            const stateChildren = await ncdAPI.getStateChildren(
              facilityDetails.data.locationHierarchy.stateId,
            );
            setDistricts(stateChildren.data);
          }

          if (facilityDetails.data?.locationHierarchy?.districtId) {
            const districtChildren = await ncdAPI.getDistrictChildren(
              facilityDetails.data.locationHierarchy.districtId,
            );
            setTalukas(districtChildren.data);
          }

          if (facilityDetails.data?.locationHierarchy?.talukaId) {
            const talukaChildren = await ncdAPI.getTalukaChildren(
              facilityDetails.data.locationHierarchy.talukaId,
            );
            setPHCs(talukaChildren.data);
          }

          const phcChildren = await ncdAPI.getPHCChildren(facility);
          setSubcenters(phcChildren.data);

          setIsPageLoading(false);
        } else {
          const stateChildren = await ncdAPI.getStateChildren(
            ncduser?.stateCode,
          );
          setDistricts(stateChildren.data);

          const districtChildren = await ncdAPI.getDistrictChildren(
            ncduser?.facility,
          );
          setTalukas(districtChildren.data);

          setSelectedDistrict(ncduser?.facility);

          setIsPageLoading(false);
        }
      } else {
        const response = await ncdAPI.getVillages(facility);
        const userresp = await ncdAPI.getSubcenterUsers(facility);

        if (response) {
          setformDetails(response.data);
          setvillages(response.data.villages);
          setsubUsers(userresp.data);
          setIsPageLoading(false);
        } else {
          setIsPageLoading(false);
        }
      }
    } catch (error) {
      setIsPageLoading(false);
      console.error("Error in getting details:", error);
    }
  };

  const houseOptions = [
    { value: "Kuccha", label: "Kuccha" },
    {
      value: "Pucca with stone and mortar",
      label: "Pucca with stone and mortar",
    },
    {
      value: "Pucca with bricks and concrete",
      label: "Pucca with bricks and concrete",
    },
    { value: "Other", label: "Other" },
  ];

  const toiletOptions = [
    {
      value: "Flush toilet with running water",
      label: "Flush toilet with running water",
    },
    {
      value: "Flush toilet without water",
      label: "Flush toilet without water",
    },
    {
      value: "Pit toilet with running water supply",
      label: "Pit toilet with running water supply",
    },
    {
      value: "Pit toilet without water supply",
      label: "Pit toilet without water supply",
    },
    { value: "Other", label: "Other" },
  ];

  const drinkingwaterOptions = [
    { value: "Tap water", label: "Tap water" },
    { value: "Hand pump within house", label: "Hand pump within house" },
    {
      value: "Hand pump outside of house",
      label: "Hand pump outside of house",
    },
    { value: "Well", label: "Well" },
    { value: "Tank", label: "Tank" },
    { value: "River", label: "River" },
    { value: "Pond", label: "Pond" },
    { value: "Other", label: "Other" },
  ];

  const electricityOptions = [
    { value: "Electricity supply", label: "Electricity supply" },
    { value: "Generator", label: "Generator" },
    { value: "Solar power", label: "Solar power" },
    { value: "WeKerosene lamp", label: "Kerosene lamp" },
    { value: "Other", label: "Other" },
  ];

  const vehicleOptions = [
    { value: "Motor bike", label: "Motor bike" },
    { value: "Car", label: "Car" },
    { value: "Tractor", label: "Tractor" },
    { value: "Other", label: "Other" },
  ];

  const fuelOptions = [
    { value: "Firewood", label: "Firewood" },
    { value: "Crop residue", label: "Crop residue" },
    { value: "Cow dung cake", label: "Cow dung cake" },
    { value: "Coal", label: "Coal" },
    { value: "Kerosene", label: "Kerosene" },
    { value: "LPG", label: "LPG" },
    { value: "Other", label: "Other" },
  ];

  const CheckboxOption = (props) => {
    return (
      <components.Option {...props}>
        <div className="dropdown-checkbox-wrapper">
          <input
            type="checkbox"
            checked={props.isSelected}
            onChange={() => null}
            className="dropdown-checkbox-input"
          />
          <span className="dropdown-checkbox-label">{props.label}</span>
        </div>
      </components.Option>
    );
  };

  const SingleSelect = ({
    name,
    value,
    onChange,
    options,
    disabled,
    placeholder,
  }) => {
    const selectedObj =
      options.find((opt) => opt.value === value) ||
      (value ? { value, label: value } : null);
    return (
      <Select
        maxMenuHeight={200}
        isDisabled={disabled}
        name={name}
        value={selectedObj}
        onChange={(selectedOption) => {
          if (onChange) {
            onChange({
              target: {
                name: name,
                value: selectedOption ? selectedOption.value : "",
                type: "select-one",
              },
            });
          }
        }}
        options={options}
        classNamePrefix="react-select options-select"
        placeholder={placeholder || "Select"}
      />
    );
  };

  const religionOptions = [
    { value: "Hindu", label: "Hindu" },
    { value: "Muslim", label: "Muslim" },
    { value: "Christian", label: "Christian" },
    { value: "Sikh", label: "Sikh" },
    { value: "Buddhist", label: "Buddhist" },
    { value: "Jain", label: "Jain" },
    { value: "Other", label: "Other" },
  ];

  const casteOptions = [
    { value: "General", label: "General" },
    { value: "SC", label: "SC" },
    { value: "ST", label: "ST" },
    { value: "OBC", label: "OBC" },
    { value: "Do not Know", label: "Do not Know" },
    { value: "Other", label: "Other" },
  ];

  const ownershipOptions = [
    { value: "Rent", label: "Rent" },
    { value: "Own", label: "Own" },
    { value: "Other", label: "Other" },
  ];

  const incomeOptions = [
    { value: "0-10,000", label: "0-10,000" },
    { value: "10,000-20,000", label: "10,000-20,000" },
    { value: "20,000-30,000", label: "20,000-30,000" },
    { value: "30,000-50,000", label: "30,000-50,000" },
    { value: "50,000-100,000", label: "50,000-100,000" },
    { value: "100,000-2,00,000", label: "100,000-2,00,000" },
    { value: "2,00,000", label: ">2,00,000" },
    { value: "Do not know", label: "Do not know" },
  ];

  const genderOptions = [
    { value: "Male", label: "Male" },
    { value: "Female", label: "Female" },
    { value: "Other", label: "Transgender" },
  ];

  const maritalStatusOptions = [
    { value: "Single", label: "Single" },
    { value: "Married", label: "Married" },
    { value: "Separated/Divorced", label: "Separated/Divorced" },
    { value: "Widow/Widower", label: "Widow/Widower" },
  ];

  const educationOptions = [
    { value: "Illiterate", label: "Illiterate" },
    { value: "Literate", label: "Literate" },
    {
      value: "Literate without formal schooling",
      label: "Literate without formal schooling",
    },
    { value: "Below primary", label: "Below primary" },
    { value: "Primary", label: "Primary" },
    { value: "Middle", label: "Middle" },
    { value: "Matriculation/Secondary", label: "Matriculation/Secondary" },
    {
      value: "Non-technical diploma or certificate not equal to degree",
      label: "Non-technical diploma or certificate not equal to degree",
    },
    {
      value: "Technical diploma or certificate not equal to degree",
      label: "Technical diploma or certificate not equal to degree",
    },
    { value: "Graduate and above", label: "Graduate and above" },
  ];

  const mobileOwnerOptions = [
    { value: "Self", label: "Self" },
    { value: "Family Member", label: "Family Member" },
    { value: "Other", label: "Other" },
  ];

  const residenceStatusOptions = [
    {
      value: "Staying at the house currently",
      label: "Staying at the house currently",
    },
    {
      value: "Migrated temporarily for work",
      label: "Migrated temporarily for work",
    },
    { value: "Studying in another place", label: "Studying in another place" },
    { value: "Married and left house", label: "Married and left house" },
    { value: "Other", label: "Other" },
  ];

  const healthInsuranceOptions = [
    { value: "State Health Insurance", label: "State Health Insurance" },
    { value: "PMJAY", label: "PMJAY" },
    {
      value: "CGHS/State Health Benefit scheme",
      label: "CGHS/State Health Benefit scheme",
    },
    { value: "Private/Other", label: "Private/Other" },
  ];

  const pvtgOptions = [
    { value: "PVTG", label: "PVTG" },
    { value: "Non-PVTG", label: "Non-PVTG" },
  ];

  const [formData, setFormData] = useState({
    individualInfo: {
      name: profileData?.name,
      personPresent: null,
      surname: null,
      fathersOrSpouseName: null,
      birthDate: formatToInputDate(profileData?.dob),
      age: null,
      healthInsurance: null,
      healthInsuranceDetails: null,
      gender: profileData?.gender,
      maritalStatus: null,
      mobileNumber:
        profileData?.originalmobile && !profileData.originalmobile.includes("X")
          ? profileData.originalmobile
          : profileData?.mobile && !profileData.mobile.includes("X")
            ? profileData.mobile
            : "",
      photo: "",
      individualIds: {
        HealthId: { idValue: "", maskedValue: null },
        Pan: { idValue: "", maskedValue: null },
        VoterID: { idValue: "", maskedValue: null },
        DrivingLicense: { idValue: "", maskedValue: null },
        SECC: { idValue: "", maskedValue: null },
        NPR: { idValue: "", maskedValue: null },
        uhcId: { idValue: "", maskedValue: null },
        HealthIdAlias: { idValue: "", maskedValue: null },
      },
      additionalDetails: {
        enrollmentDate: formatToApiDate(enrollmentDate),
        education: null,
        mobileOwner: null,
        residenceStatus: null,
        caste: null,
        casteOther: null,
        religion: null,
        religionOther: null,
        anmName: "",
        smsConsentNcd: true,
        smsConsentMProg: true,
      },
    },
    familyInfo: {
      additionalDetails: {
        numberid: null,
        asha: null,
        hamlet: null,
        house: null,
        houseOther: null,
        toilet: null,
        toiletOther: null,
        water: null,
        waterOther: null,
        electricity: null,
        electricityOther: null,
        vehicle: null,
        vehicleOther: null,
        fuel: null,
        fuelOther: null,
        rationCardAPL: null,
        income: null,
        houseOwnershipStatus: null,
        ration: null,
        idOther: null,
        idOtherVal: null,
      },
      addressInfo: {
        landmark: null,
        addressDetails: null,
        subcenterName: "",
        subcenterId: user?.facility || null,
        village: "",
        villageId: null,
        phc: "",
        phcId: null,
        villageOther: null,
      },
      familyHeadName: null,
      contactDetail: null,
    },
    enrollmentFormId: enrollmentForId,
  });

  // Refs

  const enrollmentDateRef = useRef(null);
  const nameRef = useRef(null);
  const genderRef = useRef(null);
  const ageRef = useRef(null);
  const mobileNumberRef = useRef(null);
  const villageRef = useRef(null);
  const birthDateRef = useRef(null);
  const healthInsuranceDetailsRef = useRef(null);

  const errorKeyMap = {
    "individualInfo.name": "name",
    "individualInfo.surname": "surname",
    "individualInfo.gender": "gender",
    "individualInfo.age": "age",
    "individualInfo.birthDate": "birthDate",
    "individualInfo.mobileNumber": "mobileNumber",
    "familyInfo.addressInfo.villageId": "villageId",
    "individualInfo.healthInsuranceDetails": "healthInsuranceDetails",
  };

  const [, setOtherDis] = useState({
    toilet: true,
    water: true,
    electricity: true,
    vehicle: true,
    fuel: true,
    religion: true,
    caste: true,
  });

  const handleChange = (e) => {
    const { name, value, type } = e.target;

    let parsedValue = Array.isArray(value) ? value.join(",") : value;

    // Handle PVTG Status selection
    if (name === "individualInfo.pvtgIndividual") {
      const pvtgValue = value === "PVTG";
      setFormData((prev) => ({
        ...prev,
        individualInfo: {
          ...prev.individualInfo,
          pvtgIndividual: pvtgValue,
        },
      }));
      return;
    }

    // Handle Health Insurance selection - reset Details of Scheme when "No" is selected
    if (name === "individualInfo.healthInsurance") {
      const isHealthInsuranceYes = value === "true" || value === true;
      setFormData((prev) => ({
        ...prev,
        individualInfo: {
          ...prev.individualInfo,
          healthInsurance: isHealthInsuranceYes,
          healthInsuranceDetails: !isHealthInsuranceYes
            ? ""
            : prev.individualInfo.healthInsuranceDetails,
        },
      }));
      return;
    }

    // Update form data
    setFormData((prev) => {
      const keys = name.split(".");
      const lastKey = keys.pop();
      const deepObj = keys.reduce((acc, key) => acc[key], prev);
      deepObj[lastKey] = value;
      return { ...prev };
    });

    const fieldMatch = name.match(/(?:.|^)(\w+)$/);
    const fieldKey2 = fieldMatch ? fieldMatch[1].replace("Other", "") : null;

    if (fieldKey2 && name.endsWith(fieldKey2)) {
      setOtherDis((prev) => ({
        ...prev,
        [fieldKey2]: value !== "Other",
      }));
    }

    if (type === "radio" && (value === "true" || value === "false")) {
      parsedValue = value === "true";
    }

    let calculatedAge = null;

    if (name === "individualInfo.birthDate") {
      if (value && value.trim() !== "") {
        try {
          // Date input gives YYYY-MM-DD format, convert directly to Date object
          const dateObj = new Date(value);
          calculatedAge = calculateAge(dateObj);
          if (!isNaN(calculatedAge) && calculatedAge >= 0) {
            setAge(calculatedAge);
          } else {
            setAge(null);
          }
        } catch (error) {
          setAge(null);
        }
      } else {
        setAge(null);
      }
    }

    if (name === "individualInfo.age") {
      // Only digits allowed
      if (value && !/^\d*$/.test(value)) {
        setFormErrors((prev) => ({
          ...prev,
          age: "Age must contain only numbers",
        }));
        return;
      }

      if (value === "") {
        setAge(null);
        setFormErrors((prev) => {
          const err = { ...prev };
          delete err.age;
          return err;
        });

        setFormData((prev) => ({
          ...prev,
          individualInfo: {
            ...prev.individualInfo,
            age: "",
            birthDate: "",
          },
        }));
        return;
      }

      const ageNum = parseInt(value);

      if (ageNum < 0) {
        setFormErrors((prev) => ({
          ...prev,
          age: "Age cannot be negative",
        }));
        return;
      }

      if (ageNum > 120) {
        setFormErrors((prev) => ({
          ...prev,
          age: "Age cannot be greater than 120",
        }));
        return;
      }

      // Clear error
      setFormErrors((prev) => {
        const err = { ...prev };
        delete err.age;
        return err;
      });

      setAge(ageNum);

      // Calculate DOB
      const today = new Date();
      const dob = new Date(
        today.getFullYear() - ageNum,
        today.getMonth(),
        today.getDate(),
      );

      const formattedDOB = dob.toISOString().split("T")[0];

      setFormData((prev) => ({
        ...prev,
        individualInfo: {
          ...prev.individualInfo,
          age: ageNum,
          birthDate: formattedDOB,
        },
      }));

      return;
    }

    // Real-time validation for phone numbers
    if (name === "individualInfo.mobileNumber") {
      if (value && !/^\d{0,10}$/.test(value)) {
        setFormErrors((prev) => ({
          ...prev,
          mobileNumber: "Mobile number must contain only digits",
        }));
        return; // Prevent further state updates
      } else if (value && value.length > 0 && value.length < 10) {
        setFormErrors((prev) => ({
          ...prev,
          mobileNumber: "Mobile number must be 10 digits",
        }));
      } else {
        setFormErrors((prev) => {
          const newErrors = { ...prev };
          delete newErrors.mobileNumber;
          return newErrors;
        });
      }
    } else if (name === "familyInfo.contactDetail") {
      if (value && !/^\d{0,10}$/.test(value)) {
        setFormErrors((prev) => ({
          ...prev,
          contactDetail: "Telephone number must contain only digits",
        }));
        return; // Prevent further state updates
      } else if (value && value.length > 0 && value.length < 10) {
        setFormErrors((prev) => ({
          ...prev,
          contactDetail: "Telephone number must be 10 digits",
        }));
      } else {
        setFormErrors((prev) => {
          const newErrors = { ...prev };
          delete newErrors.contactDetail;
          return newErrors;
        });
      }
    } else {
      // Clear the error for other fields using errorKeyMap
      const fieldKey = errorKeyMap[name];
      if (fieldKey) {
        setFormErrors((prevErrors) => {
          const newErrors = { ...prevErrors };
          if (newErrors[fieldKey]) {
            delete newErrors[fieldKey];
          }
          return newErrors;
        });
      }
    }

    setFormData((prevState) => {
      const keys = name.split(".");

      const updatedFormData = { ...prevState };

      if (keys.length === 1) {
        return { ...prevState, [name]: parsedValue };
      } else {
        let updatedData = { ...prevState };
        let current = updatedData;
        for (let i = 0; i < keys.length - 1; i++) {
          current = current[keys[i]];
        }
        current[keys[keys.length - 1]] = parsedValue;

        if (calculatedAge !== null) {
          updatedFormData.individualInfo.age = calculatedAge; // Optional: convert to string
        }

        return { ...updatedData };
      }
    });
  };

  const idKeys = [
    "HealthId",
    "Pan",
    "VoterID",
    "DrivingLicense",
    "SECC",
    "NPR",
    "uhcId",
    "HealthIdAlias",
  ];

  const idValidationRules = {
    Pan: {
      regex: /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/, // Example: HHIPS7467K
      message: "Invalid PAN format (e.g., ABCDE1234F)",
    },
    HealthId: {
      //regex: /^[a-zA-Z0-9\-]+$/, // Simplified example
      regex: /^[a-zA-Z0-9-]+$/,
      message: "Invalid Health ID format",
    },
    VoterID: {
      regex: /^[A-Z]{3}[0-9]{7}$/, // e.g., ABC1234567
      message: "Invalid Voter ID format",
    },
    DrivingLicense: {
      regex: /^[A-Z]{2}[0-9]{13}$/, // e.g., DL0123456789012
      message: "Invalid DL format",
    },
    SECC: {
      regex: /^[0-9]{7,12}$/,
      message: "Invalid SECC ID",
    },
    NPR: {
      regex: /^[0-9]{12}$/,
      message: "Invalid NPR ID",
    },
    uhcId: {
      regex: /^[a-zA-Z0-9]{6,15}$/,
      message: "Invalid UHC ID",
    },
    HealthIdAlias: {
      regex: /^[a-zA-Z0-9\-_]{3,20}$/,
      message: "Invalid Alias format",
    },
  };

  const setNestedValue = (prevState, path, value) => {
    const keys = path.split(".");
    const updatedState = JSON.parse(JSON.stringify(prevState)); // deep clone

    let current = updatedState;
    for (let i = 0; i < keys.length - 1; i++) {
      if (!current[keys[i]]) current[keys[i]] = {};
      current = current[keys[i]];
    }
    current[keys[keys.length - 1]] = value;

    return updatedState;
  };

  const formatIndividualIdsPayload = (individualIds) => {
    let hasAnyIdValue = false;
    const formatted = {};

    idKeys.forEach((key) => {
      const idValue = individualIds?.[key]?.idValue || null;

      if (idValue && idValue.trim() !== "") {
        hasAnyIdValue = true;
        formatted[key] = {
          idValue,
          maskedValue: individualIds[key]?.maskedValue || null,
        };
      } else {
        formatted[key] = null;
      }
    });

    return hasAnyIdValue
      ? formatted
      : Object.fromEntries(idKeys.map((k) => [k, null]));
  };

  const handleNestedInputChange = (e) => {
    const { name, value, type } = e.target;
    const parsedValue =
      type === "radio" && (value === "true" || value === "false")
        ? value === "true"
        : value;

    // Update form data
    setFormData((prev) => setNestedValue(prev, name, parsedValue));

    // Validation
    const parts = name.split(".");
    const lastKey = parts[parts.length - 2]; // e.g., "Pan" from "individualInfo.individualIds.Pan.idValue"

    if (idKeys.includes(lastKey) && parts[parts.length - 1] === "idValue") {
      const rule = idValidationRules[lastKey];
      if (rule && value.trim() !== "" && !rule.regex.test(value)) {
        setFormErrors((prev) => ({
          ...prev,
          [name]: rule.message,
        }));
      } else {
        setFormErrors((prev) => {
          const newErrors = { ...prev };
          delete newErrors[name];
          return newErrors;
        });
      }
    }
  };

  const handleVillageChange = async (e) => {
    const villageId = e.target.value;
    setIsPageLoading(true);

    // Clear village error if any
    setFormErrors((prevErrors) => {
      const newErrors = { ...prevErrors };
      if (newErrors["villageId"]) {
        delete newErrors["villageId"];
      }
      return newErrors;
    });

    const selectedVillage = villages.find(
      (v) => String(v.locationId) === String(villageId),
    );

    // Update formData
    setFormData((prev) => ({
      ...prev,
      familyInfo: {
        ...prev.familyInfo,
        addressInfo: {
          ...prev.familyInfo.addressInfo,
          villageId: villageId,
          village: selectedVillage?.locationName || "",
        },
      },
    }));

    // Call your API
    const facilityId =
      (user?.rolename === "MO" ||
        user?.rolename === "DEO" ||
        user?.rolename === "STAFF_NURSE") &&
      selectedSubcenter
        ? selectedSubcenter
        : user.facility;
    const vresp = await ncdAPI.getVillageData(facilityId, villageId);

    setAshas(vresp.data);

    setIsPageLoading(false);
  };

  const handleSubcenterChange = async (e) => {
    const subcenterId = e.target.value;
    setSelectedSubcenter(subcenterId);
    if (
      subcenterId &&
      (user?.rolename === "MO" ||
        user?.rolename === "DEO" ||
        user?.rolename === "STAFF_NURSE")
    ) {
      setIsPageLoading(true);
      const response = await ncdAPI.getVillages(subcenterId);
      const userresp = await ncdAPI.getSubcenterUsers(subcenterId);
      setvillages(response.data.villages);
      setsubUsers(userresp.data);
      setIsPageLoading(false);
    }
  };

  const handleDistrictChange = async (e) => {
    const districtId = e.target.value;
    setSelectedDistrict(districtId);
    if (
      districtId &&
      (user?.rolename === "STAFF_NURSE" ||
        user?.rolename === "MO" ||
        user?.rolename === "DEO")
    ) {
      setIsPageLoading(true);
      const districtChildren = await ncdAPI.getDistrictChildren(districtId);
      setTalukas(districtChildren.data);
      setSelectedTaluka(null);
      setPHCs(null);
      setSelectedPHC(null);
      setSubcenters(null);
      setSelectedSubcenter(null);
      setIsPageLoading(false);
    } else {
      setTalukas(null);
      setSelectedTaluka(null);
      setPHCs(null);
      setSelectedPHC(null);
      setSubcenters(null);
      setSelectedSubcenter(null);
    }
  };

  const handleTalukaChange = async (e) => {
    const talukaId = e.target.value;
    setSelectedTaluka(talukaId);
    if (
      talukaId &&
      (user?.rolename === "STAFF_NURSE" ||
        user?.rolename === "MO" ||
        user?.rolename === "DEO")
    ) {
      setIsPageLoading(true);
      const talukaChildren = await ncdAPI.getTalukaChildren(talukaId);
      setPHCs(talukaChildren.data);
      setSelectedPHC(null);
      setSubcenters(null);
      setSelectedSubcenter(null);
      setIsPageLoading(false);
    }
  };

  const handlePHCChange = async (e) => {
    const phcId = e.target.value;
    setSelectedPHC(phcId);
    if (
      phcId &&
      (user?.rolename === "STAFF_NURSE" ||
        user?.rolename === "MO" ||
        user?.rolename === "DEO")
    ) {
      setIsPageLoading(true);
      const phcChildren = await ncdAPI.getPHCChildren(phcId);
      setSubcenters(phcChildren.data);
      setSelectedSubcenter(null);
      setIsPageLoading(false);
    }
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setPhotoError(""); // reset error

    const allowedTypes = ["image/jpeg", "image/jpg", "image/png", "image/gif"];
    const maxSize = 100 * 1024; // 100 KB

    if (!allowedTypes.includes(file.type)) {
      setPhotoError("Supported formats: GIF, JPG, JPEG, PNG");
      e.target.value = "";
      return;
    }

    if (file.size > maxSize) {
      setPhotoError("Image size should not exceed 100 KB");
      e.target.value = "";
      return;
    }

    const reader = new FileReader();
    reader.onloadend = () => {
      const base64 = reader.result.replace(/^data:image\/\w+;base64,/, "");

      setFormData((prev) => ({
        ...prev,
        individualInfo: {
          ...prev.individualInfo,
          photo: base64,
        },
      }));
    };

    reader.readAsDataURL(file);
  };

  // Handle form submission

  const handleFormSubmit = async (e, action) => {
    e.preventDefault();

    const errors = {};

    if (!formData.individualInfo.additionalDetails.enrollmentDate) {
      errors.enrollmentDate = "Enrollment Date is required";

      toast.error(errors.enrollmentDate, {
        className: "custom-toast-error",
      });
    }

    if (!formData.individualInfo.name?.trim()) {
      errors.name = "name is required";

      toast.error(errors.name, {
        className: "custom-toast-error",
      });
    }

    if (formData.individualInfo.surname?.trim()) {
      if (!/^[A-Za-z]+$/.test(formData.individualInfo.surname.trim())) {
        errors.surname = "Surname should contain only alphabets";
        toast.error(errors.surname, {
          className: "custom-toast-error",
        });
      }
    }

    if (!formData.individualInfo.gender) {
      errors.gender = "gender is required";

      toast.error(errors.gender, {
        className: "custom-toast-error",
      });
    }

    if (!formData.individualInfo.birthDate) {
      errors.birthDate = "Date of birth is required";
      toast.error(errors.birthDate, {
        className: "custom-toast-error",
      });
    }

    if (!formData.individualInfo.age || isNaN(formData.individualInfo.age)) {
      errors.age = "Valid age is required";
      toast.error(errors.age, {
        className: "custom-toast-error",
      });
    }

    if (!formData.individualInfo.mobileNumber?.trim()) {
      errors.mobileNumber = "Mobile number is required";

      toast.error(errors.mobileNumber, {
        className: "custom-toast-error",
      });
    } else if (!/^\d{10}$/.test(formData.individualInfo.mobileNumber)) {
      errors.mobileNumber = "Mobile number must be 10 digits";

      toast.error(errors.mobileNumber, {
        className: "custom-toast-error",
      });
    }

    if (!formData.familyInfo.addressInfo.villageId?.trim()) {
      errors.villageId = "village id is required";
      toast.error(errors.villageId, {
        className: "custom-toast-error",
      });
    }

    if (
      formData.familyInfo.addressInfo.village === "Other" &&
      !formData.familyInfo.addressInfo.villageOther?.trim()
    ) {
      errors.villageOther = "Other village is required";
    }

    if (
      formData.individualInfo.pvtgIndividual === null ||
      formData.individualInfo.pvtgIndividual === undefined
    ) {
      errors.pvtgIndividual = "PVTG Status is required";

      toast.error(errors.pvtgIndividual, {
        className: "custom-toast-error",
      });
    }

    if (
      formData.individualInfo.healthInsurance === true &&
      !formData.individualInfo.healthInsuranceDetails?.trim()
    ) {
      errors.healthInsuranceDetails = "Details of scheme are required";

      toast.error(errors.healthInsuranceDetails, {
        className: "custom-toast-error",
      });
    }

    setFormErrors(errors);

    if (Object.keys(errors).length > 0) {
      // Focus on the first error field

      if (errors.enrollmentDate && enrollmentDateRef.current) {
        enrollmentDateRef.current.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
        enrollmentDateRef.current.focus();
        return;
      }

      if (errors.villageId && villageRef.current) {
        villageRef.current.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
        villageRef.current.focus();
        return;
      }
      if (errors.name && nameRef.current) {
        nameRef.current.scrollIntoView({ behavior: "smooth", block: "center" });
        nameRef.current.focus();
        return;
      }
      if (errors.gender && genderRef.current) {
        genderRef.current.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
        genderRef.current.focus();
        return;
      }
      if (errors.birthDate && birthDateRef.current) {
        birthDateRef.current.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
        birthDateRef.current.focus();
        return;
      }
      if (errors.age && ageRef.current) {
        ageRef.current.scrollIntoView({ behavior: "smooth", block: "center" });
        ageRef.current.focus();
        return;
      }
      if (errors.mobileNumber && mobileNumberRef.current) {
        mobileNumberRef.current.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
        mobileNumberRef.current.focus();
        return;
      }
      if (errors.healthInsuranceDetails && healthInsuranceDetailsRef.current) {
        healthInsuranceDetailsRef.current.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
        healthInsuranceDetailsRef.current.focus();
        return;
      }
      return;
    }

    // Format birthDate to dd-mm-yyyy before submit
    let birthDate = formData.individualInfo.birthDate;
    if (birthDate && /^\d{4}-\d{2}-\d{2}$/.test(birthDate)) {
      const [yyyy, mm, dd] = birthDate.split("-");
      birthDate = `${dd}-${mm}-${yyyy}`;
    }

    const payload = {
      ...formData,
      individualInfo: {
        ...formData.individualInfo,
        name: formData.individualInfo.name?.trim(),
        surname: formData.individualInfo.surname?.trim() || null,
        birthDate: birthDate,
        individualIds: formatIndividualIdsPayload(
          formData.individualInfo.individualIds,
        ),
      },
    };

    try {
      // console.log(payload); return false;

      setIsPageLoading(true);

      const response = await ncdAPI.registerFamily(payload);

      if (response.data?.individualId) {
        const individualId = response.data.individualId;
        setIndividualId(individualId);
        setFamilyInfo(response.data);

        // Update beneficiary details with individualId
        const beneficiaryDetails = localStorage.getItem("beneficiaryDetails");
        if (beneficiaryDetails) {
          const parsedBeneficiary = JSON.parse(beneficiaryDetails);
          parsedBeneficiary.searchedindividualId = individualId;

          if (
            user?.rolename === "MO" ||
            user?.rolename === "DEO" ||
            user?.rolename === "STAFF_NURSE"
          ) {
            const familyinforesp = await ncdAPI.getFamilyInfo(individualId);
            parsedBeneficiary.subcenterId =
              familyinforesp.data.familyInfo.addressInfo.subcenterId;
          } else {
            parsedBeneficiary.subcenterId = ncduser.facility;
          }

          localStorage.setItem(
            "beneficiaryDetails",
            JSON.stringify(parsedBeneficiary),
          );
        }

        if (profileData.hidn && profileData.hid) {
          await ncdAPI.linkAbhaNcd(individualId, {
            abhaNumber: profileData.hidn,
            abhaAddress: profileData.hid,
          });
        }

        toast.success(`NCD Enrollment Successfully Completed`);
        setIsPageLoading(false);

        // Notify parent component
        onRegistrationSuccess?.(individualId);

        // Wait a moment before updating UI to let toast show
        setTimeout(() => {
          if (action === "submitAndMove") {
            setshowCBACform(true);
            hideSection("FamilyForm");
            setShowNcdReg();
          } else {
            hideSection("FamilyForm");
            setShowNcdReg();
          }
        }, 1000);
      } else {
        toast.error("Error in family registration");
        setIsPageLoading(false);
      }
    } catch (error) {
      toast.error(error.response?.data?.message || "Something went wrong", {
        className: "custom-toast-error",
      });
      setIsPageLoading(false);
    }
  };

  return (
    <div className="program-selection-sectionn">
      <h4 className="Header_accordian">
        <span>
          <img
            src={"/images/programs_logo/ncd.svg"}
            alt=""
            style={{ width: "43px", margin: "0 10px 0 -5px" }}
          />
        </span>
        NCD ENROLLMENT
      </h4>

      <div
        className="closeDive"
        onClick={() => {
          hideSection("FamilyForm");
          setShowNcdReg();
        }}
      >
        <img src={"/images/closing.svg"} alt="Close" />
      </div>

      {isPageLoading && <Loader />}

      <form>
        <Form.Label>
          Enrollment Date <span className="error">*</span>
        </Form.Label>
        <input
          type="date"
          className="ng-date"
          placeholder="choose date"
          name="individualInfo.additionalDetails.enrollmentDate"
          value={formatToInputDate(
            formData.individualInfo.additionalDetails.enrollmentDate,
          )}
          max={enrollmentDate}
          onChange={handleDateChange}
          ref={enrollmentDateRef}
        />

        {formErrors.enrollmentDate && (
          <div className="text-danger">{formErrors.enrollmentDate}</div>
        )}

        <Accordion defaultActiveKey="0" className="accordina-faimly">
          <Accordion.Item eventKey="0">
            <Accordion.Header>Subcenter Information</Accordion.Header>
            <Accordion.Body>
              <Card className="accordian-border-fam">
                <Row className="FillIndividualDetails">
                  <Col md={4} lg={4} xs={12}>
                    <div className="d-flex align-items-center gap-2">
                      <img
                        src={"/images/district.png"}
                        alt=""
                        className="img-icon-ncdroll"
                      />
                      <Form.Group className="w-100">
                        <Form.Label>
                          District <span className="error">*</span>
                        </Form.Label>
                        <Form.Select
                          disabled={
                            user?.rolename !== "MO" &&
                            user?.rolename !== "DEO" &&
                            user?.rolename !== "STAFF_NURSE"
                          }
                          value={selectedDistrict || ""}
                          onChange={handleDistrictChange}
                        >
                          {user?.rolename === "MO" ||
                          user?.rolename === "DEO" ||
                          user?.rolename === "STAFF_NURSE" ? (
                            districts?.length > 0 ? (
                              <>
                                <option value="">Select District</option>
                                {districts.map((district) => (
                                  <option
                                    key={district.locationId}
                                    value={district.locationId}
                                  >
                                    {district.locationName}
                                  </option>
                                ))}
                              </>
                            ) : selectedDistrict &&
                              formDetails?.locationHierarchy ? (
                              <option value={selectedDistrict}>
                                {formDetails.locationHierarchy.districtName}
                              </option>
                            ) : (
                              <option value="">No districts available</option>
                            )
                          ) : (
                            <option value={formDetails?.districtId || ""}>
                              {formDetails?.district || ""}
                            </option>
                          )}
                        </Form.Select>
                      </Form.Group>
                    </div>
                  </Col>

                  <Col md={4} lg={4} xs={12}>
                    <div className="d-flex align-items-center gap-2">
                      <img
                        src={"/images/block.png"}
                        alt=""
                        className="img-icon-ncdroll"
                      />
                      <Form.Group className="w-100">
                        <Form.Label>
                          Block / Taluk Name <span className="error">*</span>
                        </Form.Label>
                        <Form.Select
                          disabled={
                            user?.rolename !== "MO" &&
                            user?.rolename !== "DEO" &&
                            user?.rolename !== "STAFF_NURSE"
                          }
                          value={selectedTaluka || ""}
                          onChange={handleTalukaChange}
                        >
                          {user?.rolename === "MO" ||
                          user?.rolename === "DEO" ||
                          user?.rolename === "STAFF_NURSE" ? (
                            talukas?.length > 0 ? (
                              <>
                                <option value="">Select Block/Taluk</option>
                                {talukas.map((taluka) => (
                                  <option
                                    key={taluka.locationId}
                                    value={taluka.locationId}
                                  >
                                    {taluka.locationName}
                                  </option>
                                ))}
                              </>
                            ) : selectedTaluka &&
                              formDetails?.locationHierarchy ? (
                              <option value={selectedTaluka}>
                                {formDetails.locationHierarchy.talukaName}
                              </option>
                            ) : (
                              <option value="">
                                {user?.rolename === "STAFF_NURSE"
                                  ? "-Select Block/Taluk-"
                                  : "No talukas available"}
                              </option>
                            )
                          ) : (
                            <option value={formDetails?.talukaId || ""}>
                              {formDetails?.taluka || ""}
                            </option>
                          )}
                        </Form.Select>
                      </Form.Group>
                    </div>
                  </Col>

                  <Col md={4} lg={4} xs={12}>
                    <div className="d-flex align-items-center gap-2">
                      <img
                        src={"/images/phc.png"}
                        alt=""
                        className="img-icon-ncdroll"
                      />
                      <Form.Group className="w-100">
                        <Form.Label>
                          PHC <span className="error">*</span>
                        </Form.Label>
                        <Form.Select
                          disabled={
                            user?.rolename !== "MO" &&
                            user?.rolename !== "DEO" &&
                            user?.rolename !== "STAFF_NURSE"
                          }
                          value={selectedPHC || ""}
                          onChange={handlePHCChange}
                        >
                          {user?.rolename === "MO" ||
                          user?.rolename === "DEO" ||
                          user?.rolename === "STAFF_NURSE" ? (
                            phcs?.length > 0 ? (
                              <>
                                <option value="">Select PHC</option>
                                {phcs.map((phc) => (
                                  <option
                                    key={phc.locationId}
                                    value={phc.locationId}
                                  >
                                    {phc.locationName}
                                  </option>
                                ))}
                              </>
                            ) : selectedPHC && formDetails?.facilityName ? (
                              <option value={selectedPHC}>
                                {formDetails.facilityName}
                              </option>
                            ) : (
                              <option value="">
                                {user?.rolename === "STAFF_NURSE"
                                  ? "-Select PHC-"
                                  : "No PHCs available"}
                              </option>
                            )
                          ) : (
                            <option value={formDetails?.phcId || ""}>
                              {formDetails?.phc || ""}
                            </option>
                          )}
                        </Form.Select>
                      </Form.Group>
                    </div>
                  </Col>
                </Row>
              </Card>
            </Accordion.Body>

            <Accordion.Body>
              <Card className="accordian-border-fam">
                <Row className="FillIndividualDetails">
                  <Col md={4} lg={4} xs={12}>
                    <div className="d-flex align-items-center gap-2">
                      <img
                        src={"/images/subcenter.png"}
                        alt=""
                        className="img-icon-ncdroll"
                      />
                      <Form.Group className="w-100">
                        <Form.Label>
                          Sub center <span className="error">*</span>
                        </Form.Label>
                        <Form.Select
                          disabled={
                            user?.rolename !== "MO" &&
                            user?.rolename !== "DEO" &&
                            user?.rolename !== "STAFF_NURSE"
                          }
                          onChange={handleSubcenterChange}
                        >
                          {user?.rolename === "MO" ||
                          user?.rolename === "DEO" ||
                          user?.rolename === "STAFF_NURSE" ? (
                            <>
                              <option value="">Select Sub center</option>
                              {subcenters?.length > 0
                                ? subcenters.map((subcenter) => (
                                    <option
                                      key={subcenter.locationId}
                                      value={subcenter.locationId}
                                    >
                                      {subcenter.locationName}
                                    </option>
                                  ))
                                : null}
                            </>
                          ) : (
                            <option value={user?.facility || ""}>
                              {user?.facilityName || ""}
                            </option>
                          )}
                        </Form.Select>
                      </Form.Group>
                    </div>
                  </Col>

                  <Col md={4} lg={4} xs={12}>
                    <div className="d-flex align-items-center gap-2">
                      <img
                        src={"/images/village.png"}
                        alt=""
                        className="img-icon-ncdroll"
                      />
                      <Form.Group className="w-100">
                        <Form.Label>
                          Name of Village <span className="error">*</span>
                        </Form.Label>
                        {villages?.length > 0 ? (
                          <Form.Select
                            name="familyInfo.addressInfo.villageId"
                            value={
                              formData.familyInfo.addressInfo.villageId || ""
                            }
                            onChange={handleVillageChange}
                            ref={villageRef}
                          >
                            <option value="">Select Village</option>
                            {villages.map((village) => (
                              <option
                                key={village.locationId}
                                value={village.locationId}
                              >
                                {village.locationName}
                              </option>
                            ))}
                          </Form.Select>
                        ) : (
                          <Form.Select
                            disabled={
                              user?.rolename !== "MO" &&
                              user?.rolename !== "DEO" &&
                              user?.rolename !== "STAFF_NURSE"
                            }
                          >
                            <option value="">Select</option>
                          </Form.Select>
                        )}
                        {formErrors.villageId && (
                          <div className="text-danger">
                            {formErrors.villageId}
                          </div>
                        )}
                      </Form.Group>
                    </div>
                  </Col>

                  <Col md={4} lg={4} xs={12}>
                    <div className="d-flex align-items-center gap-2">
                      <img
                        src={"/images/village.png"}
                        alt=""
                        className="img-icon-ncdroll"
                      />
                      <Form.Group className="w-100">
                        <Form.Label>
                          Other Village
                          {formData.familyInfo.addressInfo.village ===
                            "Other" && <span className="error">*</span>}{" "}
                        </Form.Label>
                        <input
                          type="text"
                          className="form-control border-0 border-bottom rounded-0 shadow-none"
                          name="familyInfo.addressInfo.villageOther"
                          value={formData.familyInfo.addressInfo.villageOther}
                          disabled={
                            formData.familyInfo.addressInfo.village !== "Other"
                          }
                          onChange={handleChange}
                        />

                        {formErrors.villageOther && (
                          <div className="text-danger">
                            {formErrors.villageOther}
                          </div>
                        )}
                      </Form.Group>
                    </div>
                  </Col>
                </Row>
              </Card>
            </Accordion.Body>

            <Accordion.Body>
              <Card className="accordian-border-fam">
                <Row className="mb-3 FillIndividualDetails">
                  <Col md={4} lg={4} xs={12}>
                    <div className="d-flex align-items-center gap-2">
                      <img
                        src={"/images/ANMEnr.png"}
                        alt=""
                        className="img-icon-ncdroll"
                      />
                      <Form.Group className="w-100">
                        <Form.Label>Name of Subcenter User</Form.Label>
                        {subusers?.length > 0 ? (
                          <Form.Select
                            className="border-0 border-bottom rounded-0 shadow-none"
                            name="familyInfo.addressInfo.subcenterName"
                            value={
                              formData.familyInfo.addressInfo.subcenterName ||
                              ""
                            }
                            onChange={handleChange}
                          >
                            <option value="">Select Subcenter User</option>
                            {subusers.map((center) => (
                              <option
                                key={center.username}
                                value={center.username}
                              >
                                {center.username}{" "}
                                {center.name ? `(${center.name})` : ""}
                              </option>
                            ))}
                          </Form.Select>
                        ) : (
                          <Form.Select
                            className="border-0 border-bottom rounded-0 shadow-none"
                            disabled={
                              user?.rolename !== "MO" &&
                              user?.rolename !== "DEO" &&
                              user?.rolename !== "STAFF_NURSE"
                            }
                          >
                            <option value="">Select</option>
                          </Form.Select>
                        )}
                      </Form.Group>
                    </div>
                  </Col>

                  <Col md={4} lg={4} xs={12}>
                    <div className="d-flex align-items-center gap-2">
                      <img
                        src={"/images/asha.png"}
                        alt=""
                        className="img-icon-ncdroll"
                      />
                      <Form.Group className="w-100">
                        <Form.Label>Name of ASHA</Form.Label>
                        <Form.Select
                          className="border-0 border-bottom rounded-0 shadow-none"
                          name="individualInfo.additionalDetails.anmName"
                          value={
                            formData.individualInfo.additionalDetails.anmName
                          }
                          onChange={handleChange}
                        >
                          <option value="">Select</option>
                          {ashas?.length > 0 &&
                            ashas.map((asha) => (
                              <option key={asha.ID} value={asha.ID}>
                                {asha.ID}
                              </option>
                            ))}
                        </Form.Select>
                      </Form.Group>
                    </div>
                  </Col>

                  <Col md={4} lg={4} xs={12}>
                    <div className="d-flex align-items-center gap-2">
                      <img
                        src={"/images/hamlet.png"}
                        alt=""
                        className="img-icon-ncdroll"
                      />
                      <Form.Group className="w-100">
                        <Form.Label>Hamlet Name</Form.Label>
                        <input
                          type="text"
                          className="form-control border-0 border-bottom rounded-0 shadow-none"
                          name="familyInfo.additionalDetails.hamlet"
                          value={
                            formData.familyInfo.additionalDetails.hamlet || ""
                          }
                          onChange={handleChange}
                        />
                      </Form.Group>
                    </div>
                  </Col>
                </Row>
              </Card>
            </Accordion.Body>
          </Accordion.Item>

          {/* Family Information */}
          <Accordion.Item eventKey="1">
            <Accordion.Header>Family Information</Accordion.Header>
            <Accordion.Body>
              <Card className=" accordian-border-fam">
                <Row className="mb-3 FillIndividualDetails">
                  <Col
                    md={4}
                    lg={4}
                    xs={12}
                    className="align-items-center gap-2"
                  >
                    <div className="d-flex align-items-center gap-2 familyInfoCol">
                      <img
                        src={"/images/id-number.png"}
                        alt=""
                        className="img-icon-idinf"
                      />

                      <Form.Group className="w-100">
                        <Form.Label>Number / ID</Form.Label>
                        <input
                          type="text"
                          className="form-control border-0 border-bottom rounded-0 shadow-none"
                          name="familyInfo.additionalDetails.numberid"
                          value={
                            formData.familyInfo.additionalDetails.numberid || ""
                          }
                          onChange={handleChange}
                        />
                      </Form.Group>
                    </div>
                  </Col>
                  <Col md={4} lg={4} xs={12}>
                    <div className="d-flex align-items-center gap-2 familyInfoCol">
                      <img
                        src={"/images/head-of-family.png"}
                        alt=""
                        className="img-icon-idinf"
                      />
                      <Form.Group className="w-100">
                        <Form.Label>Name of head of the household</Form.Label>
                        <input
                          type="text"
                          className="form-control border-0 border-bottom rounded-0 shadow-none"
                          name="familyInfo.familyHeadName"
                          value={formData.familyInfo.familyHeadName || ""}
                          onChange={handleChange}
                        />
                      </Form.Group>
                    </div>
                  </Col>

                  <Col md={4} lg={4} xs={12}>
                    <div className="d-flex">
                      {/* Icon Column */}
                      <div className="icon-column d-flex flex-column align-items-center justify-content-center px-2">
                        <img
                          src={"/images/type-of-house.png"}
                          alt="Type of House Icon"
                          className="icon-inline-center"
                        />
                      </div>

                      {/* Dropdown */}
                      <div className="flex-grow-1 d-flex flex-column">
                        <Form.Label className="mb-2">Type of House</Form.Label>
                        <Select
                          maxMenuHeight={200}
                          isMulti
                          closeMenuOnSelect={false}
                          hideSelectedOptions={false}
                          options={houseOptions}
                          value={houseOptions.filter((option) =>
                            formData.familyInfo.additionalDetails.house?.includes(
                              option.value,
                            ),
                          )}
                          onChange={(selectedOptions) => {
                            const values = selectedOptions.map(
                              (opt) => opt.value,
                            );
                            handleChange({
                              target: {
                                name: "familyInfo.additionalDetails.house",
                                value: values,
                              },
                            });
                          }}
                          components={{ Option: CheckboxOption }}
                          classNamePrefix="react-select options-select"
                          placeholder="Select"
                        />

                        {/* Conditionally render "Other" input */}
                        {formData.familyInfo.additionalDetails.house?.includes(
                          "Other",
                        ) && (
                          <input
                            type="text"
                            className="form-control border-0 border-bottom rounded-0 shadow-none mt-2"
                            placeholder="If other, specify"
                            name="familyInfo.additionalDetails.houseOther"
                            value={
                              formData.familyInfo.additionalDetails
                                .houseOther || ""
                            }
                            onChange={handleChange}
                          />
                        )}
                      </div>
                    </div>
                  </Col>

                  <Col md={4} lg={4} xs={12}>
                    <div className="d-flex align-items-center gap-2 familyInfoCol">
                      <img
                        src={"/images/availability-of-toilet.png"}
                        alt=""
                        className="img-icon-idinf"
                      />
                      <Form.Group className="w-100">
                        <Form.Label>Availability of Toilet</Form.Label>
                        <Select
                          maxMenuHeight={200}
                          isMulti
                          closeMenuOnSelect={false}
                          hideSelectedOptions={false}
                          options={toiletOptions}
                          value={toiletOptions.filter((option) =>
                            formData.familyInfo.additionalDetails.toilet?.includes(
                              option.value,
                            ),
                          )}
                          onChange={(selectedOptions) => {
                            const values = selectedOptions.map(
                              (opt) => opt.value,
                            );
                            handleChange({
                              target: {
                                name: "familyInfo.additionalDetails.toilet",
                                value: values,
                              },
                            });
                          }}
                          components={{ Option: CheckboxOption }}
                          classNamePrefix="react-select options-select"
                          placeholder="Select"
                        />

                        {formData.familyInfo.additionalDetails.toilet?.includes(
                          "Other",
                        ) && (
                          <input
                            type="text"
                            className="form-control border-0 border-bottom rounded-0 shadow-none mt-2"
                            placeholder="If other, specify"
                            name="familyInfo.additionalDetails.toiletOther"
                            value={
                              formData.familyInfo.additionalDetails.toiletOther
                            }
                            onChange={handleChange}
                          />
                        )}
                      </Form.Group>
                    </div>
                  </Col>
                  <Col md={4} lg={4} xs={12}>
                    <div className="d-flex align-items-center gap-2 familyInfoCol">
                      <img
                        src={"/images/source-of-drinking-water.png"}
                        alt=""
                        className="img-icon-idinf"
                      />
                      <Form.Group className="w-100">
                        <Form.Label>Source of Drinking Water</Form.Label>

                        <Select
                          maxMenuHeight={200}
                          isMulti
                          closeMenuOnSelect={false}
                          hideSelectedOptions={false}
                          options={drinkingwaterOptions}
                          value={drinkingwaterOptions.filter((option) =>
                            formData.familyInfo.additionalDetails.water?.includes(
                              option.value,
                            ),
                          )}
                          onChange={(selectedOptions) => {
                            const values = selectedOptions.map(
                              (opt) => opt.value,
                            );
                            handleChange({
                              target: {
                                name: "familyInfo.additionalDetails.water",
                                value: values,
                              },
                            });
                          }}
                          components={{ Option: CheckboxOption }}
                          classNamePrefix="react-select options-select"
                          placeholder="Select"
                        />

                        {formData.familyInfo.additionalDetails.water?.includes(
                          "Other",
                        ) && (
                          <input
                            type="text"
                            className="form-control border-0 border-bottom rounded-0 shadow-none"
                            placeholder="If other, specify"
                            name="familyInfo.additionalDetails.waterOther"
                            value={
                              formData.familyInfo.additionalDetails.waterOther
                            }
                            onChange={handleChange}
                          />
                        )}
                      </Form.Group>
                    </div>
                  </Col>
                  <Col md={4} lg={4} xs={12}>
                    <div className="d-flex align-items-center gap-2 familyInfoCol">
                      <img
                        src={"/images/availability-of-electricity.png"}
                        alt=""
                        className="img-icon-idinf"
                      />
                      <Form.Group className="w-100">
                        <Form.Label>Availability of Electricity</Form.Label>

                        <Select
                          maxMenuHeight={200}
                          isMulti
                          closeMenuOnSelect={false}
                          hideSelectedOptions={false}
                          options={electricityOptions}
                          value={electricityOptions.filter((option) =>
                            formData.familyInfo.additionalDetails.electricity?.includes(
                              option.value,
                            ),
                          )}
                          onChange={(selectedOptions) => {
                            const values = selectedOptions.map(
                              (opt) => opt.value,
                            );
                            handleChange({
                              target: {
                                name: "familyInfo.additionalDetails.electricity",
                                value: values,
                              },
                            });
                          }}
                          components={{ Option: CheckboxOption }}
                          classNamePrefix="react-select options-select"
                          placeholder="Select"
                        />

                        {formData.familyInfo.additionalDetails.electricity?.includes(
                          "Other",
                        ) && (
                          <input
                            type="text"
                            className="form-control border-0 border-bottom rounded-0 shadow-none"
                            placeholder="If other, specify"
                            name="familyInfo.additionalDetails.electricityOther"
                            value={
                              formData.familyInfo.additionalDetails
                                .electricityOther
                            }
                            onChange={handleChange}
                          />
                        )}
                      </Form.Group>
                    </div>
                  </Col>
                  <Col md={4} lg={4} xs={12}>
                    <div className="d-flex align-items-center gap-2 familyInfoCol">
                      <img
                        src={"/images/motorised-vehicle.png"}
                        alt=""
                        className="img-icon-idinf"
                      />
                      <Form.Group className="w-100">
                        <Form.Label>Motorised Vehicle</Form.Label>

                        <Select
                          maxMenuHeight={200}
                          isMulti
                          closeMenuOnSelect={false}
                          hideSelectedOptions={false}
                          options={vehicleOptions}
                          value={vehicleOptions.filter((option) =>
                            formData.familyInfo.additionalDetails.vehicle?.includes(
                              option.value,
                            ),
                          )}
                          onChange={(selectedOptions) => {
                            const values = selectedOptions.map(
                              (opt) => opt.value,
                            );
                            handleChange({
                              target: {
                                name: "familyInfo.additionalDetails.vehicle",
                                value: values,
                              },
                            });
                          }}
                          components={{ Option: CheckboxOption }}
                          classNamePrefix="react-select options-select"
                          placeholder="Select"
                        />

                        {formData.familyInfo.additionalDetails.vehicle?.includes(
                          "Other",
                        ) && (
                          <input
                            type="text"
                            className="form-control border-0 border-bottom rounded-0 shadow-none"
                            placeholder="If other, specify"
                            name="familyInfo.additionalDetails.vehicleOther"
                            value={
                              formData.familyInfo.additionalDetails.vehicleOther
                            }
                            onChange={handleChange}
                          />
                        )}
                      </Form.Group>
                    </div>
                  </Col>
                  <Col md={4} lg={4} xs={12}>
                    <div className="d-flex align-items-center gap-2 familyInfoCol">
                      <img
                        src={"/images/fuel.png"}
                        alt=""
                        className="img-icon-idinf"
                      />
                      <Form.Group className="w-100">
                        <Form.Label>Type of Fuel Used for Cooking</Form.Label>
                        <Select
                          maxMenuHeight={200}
                          isMulti
                          closeMenuOnSelect={false}
                          hideSelectedOptions={false}
                          options={fuelOptions}
                          value={fuelOptions.filter((option) =>
                            formData.familyInfo.additionalDetails.fuel?.includes(
                              option.value,
                            ),
                          )}
                          onChange={(selectedOptions) => {
                            const values = selectedOptions.map(
                              (opt) => opt.value,
                            );
                            handleChange({
                              target: {
                                name: "familyInfo.additionalDetails.fuel",
                                value: values,
                              },
                            });
                          }}
                          components={{ Option: CheckboxOption }}
                          classNamePrefix="react-select options-select"
                          placeholder="Select"
                        />

                        {formData.familyInfo.additionalDetails.fuel?.includes(
                          "Other",
                        ) && (
                          <input
                            type="text"
                            className="form-control border-0 border-bottom rounded-0 shadow-none"
                            placeholder="If other, specify"
                            name="familyInfo.additionalDetails.fuelOther"
                            value={
                              formData.familyInfo.additionalDetails.fuelOther
                            }
                            onChange={handleChange}
                          />
                        )}
                      </Form.Group>
                    </div>
                  </Col>
                  <Col md={4} lg={4} xs={12}>
                    <div className="d-flex align-items-center gap-2 familyInfoCol">
                      <img
                        src={"/images/religion.png"}
                        alt=""
                        className="img-icon-idinf"
                      />
                      <Form.Group className="w-100">
                        <Form.Label>Religion</Form.Label>
                        <select
                          className="form-select form-cback border-0 border-bottom rounded-0 shadow-none"
                          name="individualInfo.additionalDetails.religion"
                          value={
                            formData.individualInfo.additionalDetails.religion
                          }
                          onChange={handleChange}
                        >
                          <option value="">Select</option>
                          <option value="Hindu">Hindu</option>
                          <option value="Muslim">Muslim</option>
                          <option value="Christian">Christian</option>
                          <option value="Sikh">Sikh</option>
                          <option value="Buddhist">Buddhist</option>
                          <option value="Jain">Jain</option>
                          <option value="Other">Other</option>
                        </select>

                        {formData.individualInfo.additionalDetails.religion ===
                          "Other" && (
                          <input
                            type="text"
                            className="form-control border-0 border-bottom rounded-0 shadow-none"
                            placeholder="If other, specify"
                            name="individualInfo.additionalDetails.religionOther"
                            value={
                              formData.individualInfo.additionalDetails
                                .religionOther
                            }
                            onChange={handleChange}
                          />
                        )}
                      </Form.Group>
                    </div>
                  </Col>
                  <Col md={4} lg={4} xs={12}>
                    <div className="d-flex align-items-center gap-2 familyInfoCol">
                      <img
                        src={"/images/caste.png"}
                        alt=""
                        className="img-icon-idinf"
                      />
                      <Form.Group className="w-100">
                        <Form.Label>Caste</Form.Label>
                        <select
                          className="form-select form-cback border-0 border-bottom rounded-0 shadow-none"
                          name="individualInfo.additionalDetails.caste"
                          value={
                            formData.individualInfo.additionalDetails.caste
                          }
                          onChange={handleChange}
                        >
                          <option value="">Select</option>
                          <option value="General">General</option>
                          <option value="SC">SC</option>
                          <option value="ST">ST</option>
                          <option value="OBC">OBC</option>
                          <option value="Do not Know">Do not Know</option>
                          <option value="Other">Other</option>
                        </select>

                        {formData.individualInfo.additionalDetails.caste ===
                          "Other" && (
                          <input
                            type="text"
                            className="form-control border-0 border-bottom rounded-0 shadow-none"
                            placeholder="If other, specify"
                            name="individualInfo.additionalDetails.casteOther"
                            value={
                              formData.individualInfo.additionalDetails
                                .casteOther
                            }
                            onChange={handleChange}
                          />
                        )}
                      </Form.Group>
                    </div>
                  </Col>
                  <Col md={4} lg={4} xs={12}>
                    <div className="d-flex align-items-center gap-2 familyInfoCol">
                      <img
                        src={"/images/contact-details.png"}
                        alt=""
                        className="img-icon-idinf"
                      />
                      <Form.Group className="w-100">
                        <Form.Label>Contact Details</Form.Label>
                        <input
                          type="text"
                          className="form-control border-0 border-bottom rounded-0 shadow-none"
                          name="familyInfo.contactDetail"
                          value={formData.familyInfo.contactDetail}
                          onChange={handleChange}
                        />
                      </Form.Group>
                    </div>
                  </Col>
                  <Col md={4} lg={4} xs={12}>
                    <div className="d-flex align-items-center gap-2 familyInfoCol">
                      <img
                        src={"/images/rationcard.png"}
                        alt=""
                        className="img-icon-idinf"
                      />
                      <Form.Group className="w-100">
                        <Form.Label>Ration Card</Form.Label>
                        <input
                          type="text"
                          className="form-control border-0 border-bottom rounded-0 shadow-none"
                          name="familyInfo.additionalDetails.ration"
                          value={formData.familyInfo.additionalDetails.ration}
                          onChange={handleChange}
                        />
                      </Form.Group>
                    </div>
                  </Col>
                  <Col md={4} lg={4} xs={12}>
                    <div className="d-flex">
                      <div className="icon-column d-flex flex-column align-items-center justify-content-center px-2">
                        <img
                          src={"/images/house-ownership-status.png"}
                          alt=""
                          className="icon-inline-center"
                        />
                      </div>
                      <div className="flex-grow-1 d-flex flex-column justify-content-between">
                        <Form.Label className="mb-2">
                          House Ownership Status
                        </Form.Label>
                        <select
                          className="form-select form-cback border-0 border-bottom rounded-0 shadow-none"
                          name="familyInfo.additionalDetails.houseOwnershipStatus"
                          value={
                            formData.familyInfo.additionalDetails
                              .houseOwnershipStatus
                          }
                          onChange={handleChange}
                        >
                          <option value="">Select</option>
                          <option value="Rent">Rent</option>
                          <option value="Own">Own</option>
                          <option value="Other">Other</option>
                        </select>
                      </div>
                    </div>
                  </Col>
                  <Col md={4} lg={4} xs={12}>
                    <div className="d-flex">
                      {/* Icon Column */}
                      <div className="icon-column d-flex flex-column align-items-center justify-content-center px-2">
                        <img
                          src={"/images/address-info.png"}
                          alt="Address Icon"
                          className="icon-inline-center"
                        />
                      </div>

                      {/* Label + Input Column */}
                      <div className="flex-grow-1 d-flex flex-column justify-content-between">
                        <Form.Label className="mb-2">
                          Address Information
                        </Form.Label>
                        <input
                          type="text"
                          className="form-control border-0 border-bottom rounded-0 shadow-none"
                          name="familyInfo.addressInfo.addressDetails"
                          value={formData.familyInfo.addressInfo.addressDetails}
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </Col>
                  <Col md={4} lg={4} xs={12}>
                    <div className="d-flex">
                      {/* Icon Column */}
                      <div className="icon-column d-flex flex-column align-items-center justify-content-center px-2">
                        <img
                          src={"/images/landmark.png"}
                          alt="Landmark Icon"
                          className="icon-inline-center"
                        />
                      </div>

                      {/* Label + Input Field */}
                      <div className="flex-grow-1 d-flex flex-column justify-content-between">
                        <Form.Label className="mb-2">Landmark</Form.Label>
                        <input
                          type="text"
                          className="form-control border-0 border-bottom rounded-0 shadow-none"
                          name="familyInfo.addressInfo.landmark"
                          value={formData.familyInfo.addressInfo.landmark}
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </Col>

                  <Col md={4} lg={4} xs={12}>
                    <div className="d-flex mt-4">
                      {/* Icon Column */}
                      <div className="icon-column d-flex flex-column align-items-center justify-content-center px-2">
                        <img
                          src={"/images/apl-bpl.png"}
                          alt="APL/BPL Icon"
                          className="icon-inline-center"
                        />
                      </div>

                      {/* Label + Radio Buttons Column */}
                      <div className="flex-grow-1 d-flex flex-column justify-content-between">
                        <Form.Label className="mb-2">APL/BPL</Form.Label>
                        <div className="d-flex gap-3">
                          <div className="form-check">
                            <input
                              className="form-check-input"
                              type="radio"
                              id="apl"
                              name="familyInfo.additionalDetails.rationCardAPL"
                              value="true"
                              checked={
                                formData.familyInfo.additionalDetails
                                  .rationCardAPL === true
                              }
                              onChange={handleChange}
                            />
                            <label className="form-check-label" htmlFor="apl">
                              APL
                            </label>
                          </div>
                          <div className="form-check">
                            <input
                              className="form-check-input"
                              type="radio"
                              id="bpl"
                              name="familyInfo.additionalDetails.rationCardAPL"
                              value="false"
                              checked={
                                formData.familyInfo.additionalDetails
                                  .rationCardAPL === false
                              }
                              onChange={handleChange}
                            />
                            <label className="form-check-label" htmlFor="bpl">
                              BPL
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Col>
                  <Col md={4} lg={4} xs={12}>
                    <div className="d-flex mt-4">
                      {/* Icon Column */}
                      <div className="icon-column d-flex flex-column align-items-center justify-content-center px-2">
                        <img
                          src={"/images/annual-income.png"}
                          alt="Annual Income Icon"
                          className="icon-inline-center"
                        />
                      </div>

                      {/* Label + Select Field Column */}
                      <div className="flex-grow-1 d-flex flex-column justify-content-between">
                        <Form.Label className="mb-2">
                          Annual Household Income
                        </Form.Label>
                        <select
                          className="form-select form-cback border-0 border-bottom rounded-0 shadow-none"
                          name="familyInfo.additionalDetails.income"
                          value={formData.familyInfo.additionalDetails.income}
                          onChange={handleChange}
                        >
                          <option value="">Select</option>
                          <option value="0-10,000">0-10,000</option>
                          <option value="10,000-20,000">10,000-20,000</option>
                          <option value="20,000-30,000">20,000-30,000</option>
                          <option value="30,000-50,000">30,000-50,000</option>
                          <option value="50,000-100,000">50,000-100,000</option>
                          <option value="100,000-2,00,000">
                            100,000-2,00,000
                          </option>
                          <option value="2,00,000">&gt;2,00,000</option>
                          <option value="Do not know">Do not know</option>
                        </select>
                      </div>
                    </div>
                  </Col>
                </Row>
              </Card>
            </Accordion.Body>
          </Accordion.Item>

          {/* Fill Individual Details */}
          <Accordion.Item eventKey="2">
            <Accordion.Header>Fill Individual Details</Accordion.Header>
            <Accordion.Body>
              <Row className="mb-3 FillIndividualDetails">
                <Col md={12} lg={12} xs={12}>
                  <Col md={3} lg={3} xs={12}>
                    <Form.Group>
                      <div className="photo_cont position-relative">
                        {formData.individualInfo.photo && (
                          <button
                            type="button"
                            className="removeicon"
                            onClick={(e) => {
                              e.preventDefault();
                              setFormData((prev) => ({
                                ...prev,
                                individualInfo: {
                                  ...prev.individualInfo,
                                  photo: "",
                                },
                              }));
                              setPhotoError("");

                              if (fileInputRef.current) {
                                fileInputRef.current.value = "";
                              }
                            }}
                          >
                            X
                          </button>
                        )}

                        {/* ✅ ONLY IMAGE IS CLICKABLE */}
                        <Form.Label
                          htmlFor="photo-upload"
                          style={{ cursor: "pointer" }}
                        >
                          <img
                            src={
                              formData.individualInfo.photo
                                ? `data:image/png;base64,${formData.individualInfo.photo}`
                                : "/images/default-image-material.png"
                            }
                            alt="Preview"
                            className="w-100 mb-0"
                          />
                        </Form.Label>
                      </div>

                      <Form.Control
                        ref={fileInputRef}
                        type="file"
                        id="photo-upload"
                        accept="image/*"
                        style={{ display: "none" }}
                        onChange={handleImageChange}
                      />

                      {/* ✅ Error below photo */}
                      {photoError && (
                        <div className="text-danger mt-1">{photoError}</div>
                      )}
                    </Form.Group>
                  </Col>
                </Col>

                <Col md={4} lg={4} xs={12}>
                  <div className="d-flex align-items-center gap-2 familyInfoCol">
                    <img
                      src={"/images/name.png"}
                      alt=""
                      className="img-icon-idinf"
                    />
                    <Form.Group className="w-100">
                      <Form.Label>
                        Name <span className="error">*</span>
                      </Form.Label>
                      <input
                        type="text"
                        className="form-control border-0 border-bottom rounded-0 shadow-none"
                        ref={nameRef}
                        name="individualInfo.name"
                        value={formData.individualInfo.name}
                        onChange={handleChange}
                      />
                      {formErrors.name && (
                        <div className="text-danger">{formErrors.name}</div>
                      )}
                    </Form.Group>
                  </div>
                </Col>
                <Col md={4} lg={4} xs={12}>
                  <div className="d-flex align-items-center gap-2 familyInfoCol">
                    <img
                      src={"/images/surname.png"}
                      alt=""
                      className="img-icon-idinf"
                    />
                    <Form.Group className="w-100">
                      <Form.Label>Surname</Form.Label>
                      <input
                        type="text"
                        className="form-control border-0 border-bottom rounded-0 shadow-none"
                        name="individualInfo.surname"
                        value={formData.individualInfo.surname || ""}
                        onChange={handleChange}
                      />
                      {formErrors.surname && (
                        <div className="text-danger">{formErrors.surname}</div>
                      )}
                    </Form.Group>
                  </div>
                </Col>
                <Col md={4} lg={4} xs={12}>
                  <div className="d-flex align-items-start gap-2 familyInfoCol">
                    <img
                      src={"/images/gender.png"}
                      alt=""
                      className="img-icon-idinf"
                    />
                    <div className="d-flex flex-column w-100">
                      <Form.Label>
                        Gender<span className="error">*</span>
                      </Form.Label>
                      <select
                        className="form-select form-cback border-0 border-bottom rounded-0 shadow-none"
                        name="individualInfo.gender"
                        value={formData.individualInfo.gender}
                        ref={genderRef}
                        onChange={handleChange}
                        disabled
                      >
                        <option value="">Select</option>
                        <option value="Male">Male</option>
                        <option value="Female">Female</option>
                        <option value="Other">Transgender</option>
                      </select>
                      {formErrors.gender && (
                        <div className="text-danger">{formErrors.gender}</div>
                      )}
                    </div>
                  </div>
                </Col>
                <Col md={4} lg={4} xs={12}>
                  <div className="d-flex align-items-start gap-2 familyInfoCol">
                    <img
                      src={"/images/marital-status.png"}
                      alt=""
                      className="img-icon-idinf"
                    />
                    <div className="d-flex flex-column w-100">
                      <Form.Label> Marital Status</Form.Label>
                      <select
                        className="form-select form-cback border-0 border-bottom rounded-0 shadow-none"
                        name="individualInfo.maritalStatus"
                        value={formData.individualInfo.maritalStatus}
                        onChange={handleChange}
                      >
                        <option value="">Select</option>
                        <option value="Single">Single</option>
                        <option value="Married">Married</option>
                        <option value="Separated/Divorced">
                          Separated/Divorced
                        </option>
                        <option value="Widow/Widower">Widow/Widower</option>
                      </select>
                    </div>
                  </div>
                </Col>
                <Col md={4} lg={4} xs={12}>
                  <div className="d-flex align-items-center gap-2">
                    <img
                      src={"/images/father-name.png"}
                      alt=""
                      className="img-icon-idinf"
                    />
                    <Form.Group className="w-100">
                      <Form.Label>Father Name / Spouse Name</Form.Label>
                      <input
                        type="text"
                        className="form-control border-0 border-bottom rounded-0 shadow-none"
                        name="individualInfo.fathersOrSpouseName"
                        value={formData.individualInfo.fathersOrSpouseName}
                        onChange={handleChange}
                      />
                    </Form.Group>
                  </div>
                </Col>
                <Col md={4} lg={4} xs={12}>
                  <div className="d-flex align-items-center gap-2">
                    <img
                      src={"/images/dateofbirth.png"}
                      alt=""
                      className="img-icon-idinf"
                    />
                    <Form.Group className="w-100">
                      <Form.Label>
                        Date of birth <span className="error">*</span>
                      </Form.Label>
                      <input
                        type="date"
                        className="ng-date"
                        placeholder="choose date"
                        name="individualInfo.birthDate"
                        value={formData.individualInfo.birthDate}
                        ref={birthDateRef}
                        onChange={handleChange}
                      />

                      {formErrors.birthDate && (
                        <div className="text-danger">
                          {formErrors.birthDate}
                        </div>
                      )}
                    </Form.Group>
                  </div>
                </Col>
                <Col md={4} lg={4} xs={12}>
                  <div className="d-flex align-items-center gap-2">
                    <img
                      src={"/images/age.png"}
                      alt=""
                      className="img-icon-idinf"
                    />
                    <Form.Group className="w-100">
                      <Form.Label>
                        Age <span className="error">*</span>
                      </Form.Label>
                      <input
                        type="text"
                        className="form-control border-0 border-bottom rounded-0 shadow-none"
                        name="individualInfo.age"
                        value={age}
                        ref={ageRef}
                        onChange={handleChange}
                      />
                      {formErrors.age && (
                        <div className="text-danger">{formErrors.age}</div>
                      )}
                    </Form.Group>
                  </div>
                </Col>
                <Col md={4} lg={4} xs={12}>
                  <div className="d-flex align-items-start gap-2 familyInfoCol">
                    <img
                      src={"/images/education.png"}
                      alt=""
                      className="img-icon-idinf "
                    />
                    <div className="d-flex flex-column w-100">
                      <Form.Label> Education</Form.Label>
                      <select
                        className="form-select form-cback border-0 border-bottom rounded-0 shadow-none height-croll"
                        name="individualInfo.additionalDetails.education"
                        value={
                          formData.individualInfo.additionalDetails.education
                        }
                        onChange={handleChange}
                        
                      >
                        <option value="">Select</option>
                        <option value="Illiterate">Illiterate</option>
                        <option value="Literate">Literate</option>
                        <option value="Literate without formal schooling">
                          Literate without formal schooling
                        </option>
                        <option value="Below primary">Below primary</option>
                        <option value="Primary">Primary</option>
                        <option value="Primary">Middle</option>
                        <option value="Primary">Matriculation/Secondary</option>
                        <option value="Primary">
                          Non-technical diploma or certificate not equal to
                          degree
                        </option>
                        <option value="Primary">
                          Technical diploma or certificate not equal to degree
                        </option>
                        <option value="Primary">Graduate and above</option>
                      </select>
                    </div>
                  </div>
                </Col>
                <Col md={4} lg={4} xs={12}>
                  <div className="d-flex align-items-center gap-2">
                    <img
                      src={"/images/contact-details.png"}
                      alt=""
                      className="img-icon-idinf"
                    />
                    <Form.Group className="w-100">
                      <Form.Label>Telephone Number</Form.Label>
                      <input
                        type="text"
                        className="form-control border-0 border-bottom rounded-0 shadow-none"
                        name="familyInfo.contactDetail"
                        value={formData.familyInfo.contactDetail}
                        onChange={handleChange}
                        maxLength="10"
                      />
                      {formErrors.contactDetail && (
                        <div className="text-danger">
                          {formErrors.contactDetail}
                        </div>
                      )}
                    </Form.Group>
                  </div>
                </Col>
                <Col md={4} lg={4} xs={12}>
                  <div className="d-flex align-items-center gap-2">
                    <img
                      src={"/images/mobile-phone.png"}
                      alt=""
                      className="img-icon-idinf"
                    />
                    <Form.Group className="w-100">
                      <Form.Label>
                        Mobile Number <span className="error">*</span>
                      </Form.Label>
                      <input
                        type="text"
                        className="form-control border-0 border-bottom rounded-0 shadow-none"
                        name="individualInfo.mobileNumber"
                        ref={mobileNumberRef}
                        value={formData.individualInfo.mobileNumber}
                        onChange={handleChange}
                        maxLength="10"
                      />
                      {formErrors.mobileNumber && (
                        <div className="text-danger">
                          {formErrors.mobileNumber}
                        </div>
                      )}
                    </Form.Group>
                  </div>
                </Col>
                <Col md={4} lg={4} xs={12}>
                  <div className="d-flex align-items-start gap-2 familyInfoCol">
                    <img
                      src={"/images/mobile-owner.png"}
                      alt=""
                      className="img-icon-idinf"
                    />
                    <div className="d-flex flex-column w-100">
                      <Form.Label> Mobile Owner</Form.Label>
                      <select
                        className="form-select form-cback border-0 border-bottom rounded-0 shadow-none"
                        name="individualInfo.additionalDetails.mobileOwner"
                        value={
                          formData.individualInfo.additionalDetails.mobileOwner
                        }
                        onChange={handleChange}
                      >
                        <option value="">Select</option>
                        <option value="Self">Self</option>
                        <option value="Family Member">Family Member</option>
                        <option value="Other">Other</option>
                      </select>
                    </div>
                  </div>
                </Col>
                <Col md={4} lg={4} xs={4}>
                  <div className="d-flex align-items-start gap-2 familyInfoCol">
                    <img
                      src={"/images/household.png"}
                      alt=""
                      className="img-icon-idinf"
                    />
                    <div className="d-flex flex-column w-100">
                      <Form.Label> Current Status of Residence</Form.Label>
                      <select
                        className="form-select form-cback border-0 border-bottom rounded-0 shadow-none"
                        name="individualInfo.additionalDetails.residenceStatus"
                        value={
                          formData.individualInfo.additionalDetails
                            .residenceStatus
                        }
                        onChange={handleChange}
                      >
                        <option value="">Select</option>
                        <option value="Staying at the house currently">
                          Staying at the house currently
                        </option>
                        <option value="Migrated temporarily for work">
                          Migrated temporarily for work
                        </option>
                        <option value="Studying in another place">
                          Studying in another place
                        </option>
                        <option value="Married and left house">
                          Married and left house
                        </option>
                        <option value="Other">Other</option>
                      </select>
                    </div>
                  </div>
                </Col>
                <Col md={4} lg={4} xs={12}>
                  <div className="d-flex align-items-center gap-2">
                    <img
                      src={"/images/address-info.png"}
                      alt=""
                      className="img-icon-idinf"
                    />
                    <Form.Group className="w-100">
                      <Form.Label>Address</Form.Label>
                      <input
                        type="text"
                        className="form-control border-0 border-bottom rounded-0 shadow-none"
                      />
                    </Form.Group>
                  </div>
                </Col>
                <Col md={4} lg={4} xs={12}>
                  <div className="d-flex align-items-center gap-2">
                    <img
                      src={"/images/health-insurance.png"}
                      alt=""
                      className="img-icon-idinf"
                    />
                    <Form.Group>
                      <Form.Label>
                        Beneficiary of any Health Insurance scheme
                      </Form.Label>
                      <div className="d-flex gap-3">
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            type="radio"
                            id="cropBurningYes"
                            name="individualInfo.healthInsurance"
                            value="true"
                            checked={
                              formData.individualInfo.healthInsurance === true
                            }
                            onChange={handleChange}
                          />
                          <label
                            className="form-check-label"
                            htmlFor="cropBurningYes"
                          >
                            Yes
                          </label>
                        </div>
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            type="radio"
                            id="cropBurningNo"
                            name="individualInfo.healthInsurance"
                            value="false"
                            checked={
                              formData.individualInfo.healthInsurance === false
                            }
                            onChange={handleChange}
                          />
                          <label
                            className="form-check-label"
                            htmlFor="cropBurningNo"
                          >
                            No
                          </label>
                        </div>
                      </div>
                    </Form.Group>
                  </div>
                </Col>
                <Col md={4} lg={4} xs={12}>
                  <div
                    className="d-flex align-items-start gap-2 familyInfoCol"
                    ref={healthInsuranceDetailsRef}
                  >
                    <img
                      src={"/images/health-insurance.png"}
                      alt=""
                      className="img-icon-idinf"
                    />
                    <div className="d-flex flex-column w-100">
                      <Form.Label>
                        {" "}
                        Details of Scheme{" "}
                        {formData.individualInfo.healthInsurance === true && (
                          <span style={{ color: "red", marginLeft: "4px" }}>
                            *
                          </span>
                        )}
                      </Form.Label>
                      <select
                        className={`form-select form-cback border-0 border-bottom rounded-0 shadow-none ${
                          formErrors.healthInsuranceDetails &&
                          formData.individualInfo.healthInsurance === true
                            ? "is-invalid"
                            : ""
                        }`}
                        name="individualInfo.healthInsuranceDetails"
                        value={formData.individualInfo.healthInsuranceDetails}
                        onChange={handleChange}
                        disabled={!formData.individualInfo.healthInsurance}
                      >
                        <option value="">Select</option>
                        <option value="Government">Government</option>
                        <option value="Private">Private</option>
                      </select>
                      {formData.individualInfo.healthInsurance === true &&
                        formErrors.healthInsuranceDetails && (
                          <span
                            className="error"
                            style={{
                              color: "#dc3545",
                              fontSize: "0.75rem",
                              marginTop: "4px",
                            }}
                          >
                            {formErrors.healthInsuranceDetails}
                          </span>
                        )}
                    </div>
                  </div>
                </Col>
                <Col md={4} lg={4} xs={12}>
                  <div className="d-flex align-items-start gap-2 familyInfoCol">
                    <img
                      src={"/images/tribe.png"}
                      alt=""
                      className="img-icon-idinf pvtgimg"
                    />
                    <div className="d-flex flex-column w-100">
                      <Form.Label>
                        PVTG Status <span style={{ color: "red" }}>*</span>
                      </Form.Label>
                      <select
                        className="form-select form-cback border-0 border-bottom rounded-0 shadow-none"
                        name="individualInfo.pvtgIndividual"
                        value={
                          formData.individualInfo.pvtgIndividual === true
                            ? "PVTG"
                            : formData.individualInfo.pvtgIndividual === false
                              ? "Non-PVTG"
                              : ""
                        }
                        onChange={handleChange}
                        required
                      >
                        <option value="">Select</option>
                        <option value="PVTG">PVTG</option>
                        <option value="Non-PVTG">Non-PVTG</option>
                      </select>
                    </div>
                  </div>
                  {formErrors.pvtgIndividual && (
                    <div className="text-danger">
                      {formErrors.pvtgIndividual}
                    </div>
                  )}
                </Col>
              </Row>
            </Accordion.Body>
          </Accordion.Item>

          {/* ID Information */}
          <Accordion.Item eventKey="4">
            <Accordion.Header>ID Information</Accordion.Header>
            <Accordion.Body>
              <Card className="mb-3 accordian-border-fam">
                <Card.Body>
                  <Row className="mb-3">
                    <Col md={3} lg={3} xs={12}>
                      <div className="d-flex align-items-center gap-2">
                        <img
                          src={"/images/voter-id.png"}
                          alt=""
                          className="img-icon-idinf"
                        />
                        <Form.Group className="w-100">
                          <Form.Label className="mb-1">Voter ID</Form.Label>
                          <input
                            type="text"
                            className="form-control border-0 border-bottom rounded-0 shadow-none"
                            name="individualInfo.individualIds.VoterID.idValue"
                            value={
                              formData.individualInfo.individualIds.VoterID
                                ?.idValue || ""
                            }
                            onChange={handleNestedInputChange}
                          />

                          {formErrors[
                            "individualInfo.individualIds.VoterID.idValue"
                          ] && (
                            <p style={{ color: "red", fontSize: "11px" }}>
                              {
                                formErrors[
                                  "individualInfo.individualIds.VoterID.idValue"
                                ]
                              }
                            </p>
                          )}
                        </Form.Group>
                      </div>
                    </Col>
                    <Col md={3} lg={3} xs={12}>
                      <div className="d-flex align-items-center gap-2">
                        <img
                          src={"/images/id-number.png"}
                          alt=""
                          className="img-icon-idinf"
                        />
                        <Form.Group className="w-100">
                          <Form.Label className="mb-1">PAN</Form.Label>
                          <input
                            type="text"
                            className="form-control border-0 border-bottom rounded-0 shadow-none"
                            name="individualInfo.individualIds.Pan.idValue"
                            value={
                              formData.individualInfo.individualIds.Pan
                                ?.idValue || ""
                            }
                            onChange={handleNestedInputChange}
                          />

                          {formErrors[
                            "individualInfo.individualIds.Pan.idValue"
                          ] && (
                            <p style={{ color: "red", fontSize: "11px" }}>
                              {
                                formErrors[
                                  "individualInfo.individualIds.Pan.idValue"
                                ]
                              }
                            </p>
                          )}
                        </Form.Group>
                      </div>
                    </Col>
                    <Col md={3} lg={3} xs={12}>
                      <div className="d-flex align-items-center gap-2">
                        <img
                          src={"/images/id-number.png"}
                          alt=""
                          className="img-icon-idinf"
                        />
                        <Form.Group className="w-100">
                          <Form.Label className="mb-1">
                            Driving Licence
                          </Form.Label>
                          <input
                            type="text"
                            className="form-control border-0 border-bottom rounded-0 shadow-none"
                            name="individualInfo.individualIds.DrivingLicense.idValue"
                            value={
                              formData.individualInfo.individualIds
                                .DrivingLicense?.idValue || ""
                            }
                            onChange={handleNestedInputChange}
                          />
                          {formErrors[
                            "individualInfo.individualIds.DrivingLicense.idValue"
                          ] && (
                            <p style={{ color: "red", fontSize: "11px" }}>
                              {
                                formErrors[
                                  "individualInfo.individualIds.DrivingLicense.idValue"
                                ]
                              }
                            </p>
                          )}
                        </Form.Group>
                      </div>
                    </Col>
                    <Col md={3} lg={3} xs={12}>
                      <div className="d-flex align-items-center gap-2">
                        <img
                          src={"/images/id-number.png"}
                          alt=""
                          className="img-icon-idinf"
                        />
                        <Form.Group className="w-100">
                          <Form.Label className="mb-1">SECC</Form.Label>
                          <input
                            type="text"
                            className="form-control border-0 border-bottom rounded-0 shadow-none"
                            name="individualInfo.individualIds.SECC.idValue"
                            value={
                              formData.individualInfo.individualIds.SECC
                                ?.idValue || ""
                            }
                            onChange={handleNestedInputChange}
                          />
                          {formErrors[
                            "individualInfo.individualIds.SECC.idValue"
                          ] && (
                            <p style={{ color: "red", fontSize: "11px" }}>
                              {
                                formErrors[
                                  "individualInfo.individualIds.SECC.idValue"
                                ]
                              }
                            </p>
                          )}
                        </Form.Group>
                      </div>
                    </Col>
                  </Row>

                  <Row className="mb-3">
                    <Col md={3} lg={3} xs={12}>
                      <div className="d-flex align-items-center gap-2">
                        <img
                          src={"/images/id-number.png"}
                          alt=""
                          className="img-icon-idinf"
                        />
                        <Form.Group className="w-100">
                          <Form.Label className="mb-1 d-flex align-items-center gap-1">
                            NPR/BP Passport
                            <Tooltip
                              title="NPR/BP Passport Number"
                              arrow
                              placement="top"
                            >
                              <InfoOutlinedIcon
                                fontSize="small"
                                style={{ cursor: "pointer", color: "#555" }}
                              />
                            </Tooltip>
                          </Form.Label>
                          <input
                            type="text"
                            className="form-control border-0 border-bottom rounded-0 shadow-none"
                            name="individualInfo.individualIds.NPR.idValue"
                            value={
                              formData.individualInfo.individualIds.NPR
                                ?.idValue || ""
                            }
                            onChange={handleNestedInputChange}
                          />
                          {formErrors[
                            "individualInfo.individualIds.NPR.idValue"
                          ] && (
                            <p style={{ color: "red", fontSize: "11px" }}>
                              {
                                formErrors[
                                  "individualInfo.individualIds.NPR.idValue"
                                ]
                              }
                            </p>
                          )}
                        </Form.Group>
                      </div>
                    </Col>
                    <Col md={3} lg={3} xs={12}>
                      <div className="d-flex align-items-center gap-2">
                        <img
                          src={"/images/id-number.png"}
                          alt=""
                          className="img-icon-idinf"
                        />
                        <Form.Group className="w-100">
                          <Form.Label className="mb-1">UHC ID</Form.Label>
                          <input
                            type="text"
                            className="form-control border-0 border-bottom rounded-0 shadow-none"
                            name="individualInfo.individualIds.uhcId.idValue"
                            value={
                              formData.individualInfo.individualIds.uhcId
                                ?.idValue || ""
                            }
                            onChange={handleNestedInputChange}
                          />
                          {formErrors[
                            "individualInfo.individualIds.uhcId.idValue"
                          ] && (
                            <p style={{ color: "red", fontSize: "11px" }}>
                              {
                                formErrors[
                                  "individualInfo.individualIds.uhcId.idValue"
                                ]
                              }
                            </p>
                          )}
                        </Form.Group>
                      </div>
                    </Col>
                    <Col md={3} lg={3} xs={12}>
                      <div className="d-flex align-items-center gap-2">
                        <img
                          src={"/images/id-number.png"}
                          alt=""
                          className="img-icon-idinf"
                        />
                        <Form.Group className="w-100">
                          <Form.Label className="mb-1">
                            Other ID Type
                          </Form.Label>
                          <input
                            type="text"
                            className="form-control border-0 border-bottom rounded-0 shadow-none"
                            name="familyInfo.additionalDetails.idOther"
                            value={
                              formData.familyInfo.additionalDetails?.idOther ||
                              ""
                            }
                            onChange={handleNestedInputChange}
                          />
                          {formErrors[
                            "individualInfo.individualIds.idOther"
                          ] && (
                            <p style={{ color: "red", fontSize: "11px" }}>
                              {
                                formErrors[
                                  "individualInfo.individualIds.idOther"
                                ]
                              }
                            </p>
                          )}
                        </Form.Group>
                      </div>
                    </Col>
                    <Col md={3} lg={3} xs={12}>
                      <div className="d-flex align-items-center gap-2">
                        <img
                          src={"/images/id-number.png"}
                          alt=""
                          className="img-icon-idinf"
                        />
                        <Form.Group className="w-100">
                          <Form.Label className="mb-1">
                            Other ID Number
                          </Form.Label>
                          <input
                            type="text"
                            className="form-control border-0 border-bottom rounded-0 shadow-none"
                            name="familyInfo.additionalDetails.idOtherVal"
                            value={
                              formData.familyInfo.additionalDetails
                                ?.idOtherVal || ""
                            }
                            onChange={handleNestedInputChange}
                          />
                          {formErrors[
                            "individualInfo.individualIds.idOtherVal"
                          ] && (
                            <p style={{ color: "red", fontSize: "11px" }}>
                              {
                                formErrors[
                                  "individualInfo.individualIds.idOtherVal"
                                ]
                              }
                            </p>
                          )}
                        </Form.Group>
                      </div>
                    </Col>
                  </Row>
                </Card.Body>
              </Card>
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>

        <div className="fam_save_button">
          <button
            type="button"
            onClick={(e) => handleFormSubmit(e, "submitOnly")}
          >
            SAVE &amp; SUBMIT
          </button>
          {/* <button
            type="button"
            onClick={(e) => handleFormSubmit(e, "submitAndMove")}
          >
            SAVE &amp; CONTINUE TO CBAC{" "}
          </button> */}
        </div>
      </form>
    </div>
  );
};
